import { abbreviateNumber } from "../utils/formatNumbers";
import { SelectedTalent, Talent } from '../shared/types';
import RenderIfVisible from '../components/RenderIfVisible';
import TalentMini from "./TalentMini";
import { LogoIcon } from "./LogoIcon";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Overline } from "@/components/typography";

import { getCurrencySymbol } from '../shared/currency';

interface BookingSummaryProps {
    talent: Talent[],
    selectedTalent: SelectedTalent,
    userCurrency: string,
    totalPrice: number,
    totalTiktokFollowers: number,
    totalInstagramFollowers: number,
    handleRemove: (id: string) => any,
    recsLength?: number,
    onRecsClick?: () => unknown
}

function BookingSummary(props: BookingSummaryProps) {
    const { talent, selectedTalent, userCurrency, totalPrice, totalTiktokFollowers, totalInstagramFollowers, handleRemove, recsLength, onRecsClick: handleRecsClick } = props;

    return (
        <div className="mx-auto w-full max-w-100">
            {/* Row of count/price vs follower stats */}
            <div className="flex w-full max-w-80 items-center justify-between">
                <div className="shrink-0">
                    <div className="mb-2">
                        <div>{Object.keys(selectedTalent || {}).length}</div>
                        <Overline>Influencers Selected</Overline>
                    </div>
                    <div>
                        <div>{getCurrencySymbol(userCurrency) + totalPrice.toLocaleString()}</div>
                        <Overline>Estimated Price</Overline>
                    </div>
                </div>
                <div className="shrink-0">
                    <div className="my-2 flex items-center">
                        <LogoIcon brand="TikTok" className="mr-2 size-8" />
                        <div>
                            <div>{abbreviateNumber(totalTiktokFollowers)}</div>
                            <Overline>Followers</Overline>
                        </div>
                    </div>
                    <div className="my-2 flex items-center">
                        <LogoIcon brand="Instagram" className="mr-2 size-8" />
                        <div>
                            <div>{abbreviateNumber(totalInstagramFollowers)}</div>
                            <Overline>Followers</Overline>
                        </div>
                    </div>
                </div>
            </div>

            <Separator className="my-8" />

            <div className="mx-auto w-full">
                {talent.filter((tal: Talent) => selectedTalent[tal.id]).map((tal: Talent) => (
                    <RenderIfVisible defaultHeight={48} key={tal.id}>
                        <div key={tal.id}>
                            <TalentMini handleRemove={handleRemove} tal={tal} currency={userCurrency} price={selectedTalent[tal.id].price} />
                        </div>
                    </RenderIfVisible>
                ))}
            </div>

            {recsLength ? (
                <div className="my-8 text-center">
                    <Button
                        type="button"
                        variant="link"
                        className="h-auto rounded-none border-b border-dashed border-destructive p-0 text-destructive no-underline hover:border-primary hover:text-primary hover:no-underline"
                        onClick={handleRecsClick}
                    >
                        View {recsLength} Recommended Creators
                    </Button>
                </div>
            ) : null}
        </div>
    );
}

export default BookingSummary;
